import { render } from "./LoginRouteBranch.vue?vue&type=template&id=40231b60"
import script from "./LoginRouteBranch.vue?vue&type=script&lang=js"
export * from "./LoginRouteBranch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__